module.exports = __webpack_public_path__ + "img/dc9911609062ba4a7adc46d41d93271c.png";